import {
  type Invoice,
  paymentLabel,
  paymentStatusOf,
  paymentTone
} from '../invoice';

/**
 * BHP-1169: the single status a customer sees on an invoice.
 *
 * The export chip (`invoiceStatus`) is gone from the portal: it tracks our
 * Exact export, and in invoice language "open" claims unpaid — plainly false
 * on a paid invoice. What the customer needs answered is "do I still have to
 * do something", and that is what {@link paymentStatusOf} derives; the
 * wording and the tone live next to it in invoice.ts, unit-tested as plain
 * functions.
 */
export function PaymentStatusBadge({
  invoice
}: {
  invoice: Invoice;
}): JSX.Element {
  const status = paymentStatusOf(invoice);

  return (
    <span
      data-payment-status={status.kind}
      className={`rounded px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${paymentTone(
        status
      )}`}
    >
      {paymentLabel(status, invoice.currency)}
    </span>
  );
}
